import { DetailSection } from '@periscopes/general';
import { Form } from 'antd';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { useForm } from 'antd/es/form/Form';
import { useTagReference } from '@hooks';

import { TagColorSection, TagDescriptionSection, TagNameSection, TagOwnersSection } from '@tags';

export interface TagDetailsTabProps {
	sonarObjectId: number;
}

export const TagDetailsTab: React.FC<TagDetailsTabProps> = ({ sonarObjectId }) => {
	const [ form ] = useForm();
	const tag = useTagReference(sonarObjectId);

	if (!tag.id) {
		return <LoadingSpinner spinning />;
	}

	return (
		<Form form={ form }>
			<DetailSection>
				<TagColorSection tagId={ sonarObjectId } />
			</DetailSection>
			<DetailSection>
				<TagNameSection tagId={ sonarObjectId } />
			</DetailSection>
			<DetailSection>
				<TagOwnersSection tagId={ sonarObjectId } />
			</DetailSection>
			<DetailSection>
				<TagDescriptionSection tagId={ sonarObjectId } />
			</DetailSection>
		</Form>
	);
};
